export const persistedVersionIsCurrent = (capturedVersion, currentVersion) => capturedVersion === currentVersion;
